/**
 * LotoResultView.js
 */


class LotoResultView {
    constructor() {

        const mini = MINIResult.result;
        const loto6 = LOTO6Result.result;
        const loto7 = LOTO7Result.result;
        this.resultMap = new Map();
        this.resultMap.set( lotoCategory.MINI.name, mini );
        this.resultMap.set( lotoCategory.LOTO6.name, loto6 );
        this.resultMap.set( lotoCategory.LOTO7.name, loto7 );

        this.setNearResultTable(lotoCategory.MINI);
        this.setNearResultTable(lotoCategory.LOTO6);
        this.setNearResultTable(lotoCategory.LOTO7);

        //let tableLabelArray = [  "time", "date", "hon", "bon"  ];

        this.categObjArray = [ lotoCategory.MINI, lotoCategory.LOTO6, lotoCategory.LOTO7 ];
        this.categArray = [ "mini", "loto6", "loto7" ];
        this.nowCategBooArray = [ true, false, false ];

        this.setCategBtStyle();
        this.addEventListener();
    };


    addEventListener() {

        this.categArray.forEach( (val, ind) => 
            MyUtility.setElementEvent( val+'-bt', 'click', this.selectCategRadio( ind, this.nowCategBooArray, this)));

        //
        MyUtility.setElementEvent( 'input-bt', 'click', () => this.numberSearch(this.categObjArray[this.nowCategBooArray.findIndex( e => e )]) );
    };

    setCategResultTableView() {
        this.nowCategBooArray.forEach( (val, ind) => {
            let disp = val ? 'block' : 'none';
            MyUtility.setElementStyle(this.categArray[ind]+'-tableDiv', 'display', disp);
        });
    };
    

    setCategBtStyle() {

        this.nowCategBooArray.forEach( (val, ind) => {
            let back = val ? '#550bfa' : '#eaeffa';
            let color = val ? '#ffffff' : '#22265a';
            MyUtility.setElementStyle(this.categArray[ind]+'-bt', 'background-color', back);
            MyUtility.setElementStyle(this.categArray[ind]+'-bt', 'color', color);
        });
    };

    selectCategRadio(index, booArr, my) {
        let boo = booArr
        return function() {
            boo.fill(false);
            boo[index] = true;
            my.setCategBtStyle();
            my.setCategResultTableView();
        };
    };


    setNearResultTable(lotoCateg) {

        let table = document.getElementById(lotoCateg.name+'-result');

        let result = this.resultMap.get( lotoCateg.name );

        let size = result.length;
        let range = 20;

        this.makeResultTableInner(result, table, size-1, size-range);
        
    };

    setRateResultTable(lotoCateg, targetIndex) {

        let result = this.resultMap.get( lotoCateg.name );

        let size = result.length;
        let range = 20;

        let rateIndex = targetIndex-(range-5)>=0 ? targetIndex-(range-5) : 0;
        rateIndex = rateIndex+range>size ? size-range : rateIndex;
        let topIndex = rateIndex+range-1

        let table = document.createElement( 'table' );
        table.border = "1";
        table.setAttribute('id','serch-result' );
        let cap = document.createElement( 'caption' );   cap.textContent = "検索結果";
        table.appendChild(cap);

        this.makeResultTableInner(result, table, topIndex, rateIndex, 'rate-index-');

        let div = document.getElementById('serch-tableDiv');

        if(div.getElementsByTagName('table').length>0) {
            let child = div.childNodes;
            for(let i=child.length-1; i>=0; i--) {
                div.removeChild( child.item(i) );
            };
            div.appendChild(table);
        }else {
            div.appendChild(table);
        };
    };

    makeResultTableInner(result, table, topIndex, bottomIndex, lavelStr='index-') {

        let frag = document.createDocumentFragment();

        for(var i=topIndex; i>=bottomIndex; i--) {

            let obj = result[i];

            let thead = document.createElement( 'thead' );
            let tr1 = document.createElement( 'tr' );    tr1.setAttribute('id', lavelStr+obj.time);
            let td1 = document.createElement( 'td' );
            td1.colSpan = "2";
            let b1 = document.createElement( 'b' );  b1.textContent = "第"+obj.time+"回";
            td1.appendChild(b1);
            tr1.appendChild(td1);
            thead.appendChild( tr1 );
            frag.appendChild( thead );

            let tr2 = document.createElement( 'tr' );
            let td21 = document.createElement( 'td' );
            let b21 = document.createElement( 'b' );  b21.textContent = "抽せん日";
            let td22 = document.createElement( 'td' );
            let b22 = document.createElement( 'b' );  b22.textContent = obj.date.join("/");
            td21.appendChild(b21);     td22.appendChild(b22);
            tr2.appendChild(td21);    tr2.appendChild(td22);
            frag.appendChild( tr2 );


            let tr3 = document.createElement( 'tr' );
            let td31 = document.createElement( 'td' );
            let b31 = document.createElement( 'b' );  b31.textContent = "本数字";
            let td32 = document.createElement( 'td' );
            let b32 = document.createElement( 'b' );  b32.textContent =  obj.hon.join(",");
            td31.appendChild(b31);     td32.appendChild(b32);
            tr3.appendChild(td31);    tr3.appendChild(td32);
            frag.appendChild( tr3 );


            let tr4 = document.createElement( 'tr' );
            let td41 = document.createElement( 'td' );
            let b41 = document.createElement( 'b' );  b41.textContent = "ボーナス";
            let td42 = document.createElement( 'td' );
            let b42 = document.createElement( 'b' );  b42.textContent =  obj.bon.join(",");
            td41.appendChild(b41);     td42.appendChild(b42);
            tr4.appendChild(td41);    tr4.appendChild(td42);
            frag.appendChild( tr4 );

            if(i!==bottomIndex) {
                let tr5 = document.createElement( 'tr' );
                let td5 = document.createElement( 'td' );
                td5.colSpan = "2";
                //td5.style.background = "linear-gradient(to top, white, #dfdfff)";
                tr5.appendChild(td5);
                frag.appendChild( tr5 );
            };
    
        };
        table.appendChild( frag );
    };


    numberSearch(lotoCateg) {

        let result = this.resultMap.get( lotoCateg.name );
        let field = document.getElementById('numb-text');
        let numb = this.textFieldNumb(field);

        if(numb) {
    
            let intVal = Number(numb);
            let size = result.length;

            if(intVal<=size && intVal>0) {

                let neirLast = size-20;

                if(intVal <= neirLast) {
                    this.setRateResultTable( lotoCateg, intVal );
                    LotoGeneralInit.skipeBottom( 'rate-index-'+intVal, 10, 'top', false );
                }else {
                    LotoGeneralInit.skipeBottom( 'index-'+intVal, 11, 'top', false );
                };

            }else {
                field.value = '';
            };
        }else {
             field.value = '';
        };
    };


    textFieldNumb(field) {

        let val = field.value;
        let boo = true;
        if(val.length>0) {
            let arr = [];
            for(let i=0, n=val.length; i<n; i++) {
                arr.push( Number(val.charAt(i)) );
            };
            for(var i=0, n=arr.length; i<n; i++) {
                if( Number.isNaN( arr[i] ) ) {  boo = false;  };
            };
        }else {
            return null;
        };
        return boo ? Number(val) : null;
    };

};